import R from 'ramda'

const SEND_INSTAGRAM_DM_DISPLAY_TYPE = 'Send Instagram DM'
const SEND_INSTAGRAM_DM_WIDGET_TYPE = 'SEND_INSTAGRAM_MESSAGE'

const isIgDmWidgetAction = R.propEq('type', SEND_INSTAGRAM_DM_WIDGET_TYPE)

const isPlainTextResponse = dmType => action =>
  R.pathSatisfies(R.complement(R.either(R.isNil, R.isEmpty)), [
    'message',
    dmType,
    'text'
  ])(action)

const hasFallbackMessage = R.pathSatisfies(
  R.complement(R.either(R.isNil, R.isEmpty)),
  ['message', 'fallbackMessage']
)

const hasDepletedMessage = R.pathSatisfies(
  R.complement(R.either(R.isNil, R.isEmpty)),
  ['message', 'depletedMessage']
)

const includeBackupDms = R.either(hasFallbackMessage, hasDepletedMessage)
const constructPlainTextResponse = dmType => action =>
  R.path(['message', dmType, 'text'])(action)

const constructTemplateResponse = dmType => action =>
  R.pathOr('', [
    'message',
    dmType,
    'attachment',
    'payload',
    'elements',
    0,
    'subtitle'
  ])(action)

const constructGenericTemplateAction = R.applySpec({
  type: R.always(SEND_INSTAGRAM_DM_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  includeBackupDms: includeBackupDms,
  igDmText: R.cond([
    [isPlainTextResponse('message'), constructPlainTextResponse('message')],
    [R.T, constructTemplateResponse('message')]
  ]),
  igDmFallbackText: R.cond([
    [
      isPlainTextResponse('fallbackMessage'),
      constructPlainTextResponse('fallbackMessage')
    ],
    [R.T, constructTemplateResponse('fallbackMessage')]
  ]),
  igDmDepletedText: R.cond([
    [
      isPlainTextResponse('depletedMessage'),
      constructPlainTextResponse('depletedMessage')
    ],
    [R.T, constructTemplateResponse('depletedMessage')]
  ]),
  igDmImageUrl: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  igDmFallbackImageUrl: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  igDmDepletedImageUrl: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  igTemplateTitle: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  igTemplateFallbackTitle: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  igTemplateDepletedTitle: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  igTemplateActionUrl: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ]),
  igTemplateFallbackActionUrl: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ]),
  igTemplateDepletedActionUrl: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ])
})

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_INSTAGRAM_DM_DISPLAY_TYPE),
  customDmTemplate: R.pipe(
    R.prop('message'),
    R.applySpec({ message: R.prop('message') }),
    JSON.stringify
  ),
  action: R.always('TEMPLATE_CUSTOM')
})

const convertIgWidgetDmToFormDm = R.cond([
  [
    R.pathSatisfies(R.equals(true), ['isCustomTemplate']),
    constructCustomTemplateAction
  ],
  [R.T, constructGenericTemplateAction]
])

export { isIgDmWidgetAction, convertIgWidgetDmToFormDm }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/instagram/widget-to-form/send-instagram-dm.js